import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Route from 'cio/routes/base';
import { all } from 'rsvp';
import PeopleListController from './controller';
import FiltersService from 'cio/services/filters';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class ListRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  resetController(controller: PeopleListController, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setProperties({
        activeSearchBy: 'email',
        showColumnsModal: false,
        email: '',
        filters: null,
        page: 1,
      });
    }
  }

  afterModel(model: any, transition: any) {
    super.afterModel(model, transition);
    return all([this.store.findAll('short-segment'), this.filters.process.perform()]);
  }

  setupController(controller: PeopleListController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.notifyPropertyChange('segmentNames');
    controller.settings.cleanupAttributesFromSettings('customerColumns', controller.environment.current.sentAttributes);
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
